import { render, staticRenderFns } from "./GenerateReport.vue?vue&type=template&id=227d1f64&"
import script from "./GenerateReport.vue?vue&type=script&lang=ts&"
export * from "./GenerateReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports